import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

/*Set the routes for all project */
const routes: Routes = [
  {
    path: '',
    children: [
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ShopRoutingModule { }
